export const skipFlattenKey = Symbol('skipFlatten');

export const inputDefaultValue = Symbol('InputDefaultKey') as unknown as string;
